import * as React from "react";
import {
  FormControl,
  InputAdornment, InputLabel, MenuItem,
  TextField,
  Select
} from "@mui/material";

import CompanyIcon from "@mui/icons-material/Business";
import { Formik } from "formik";
import { Col, Row } from "react-bootstrap";


const DeliveryAddress = ({ values, errors, handleChange, handleSubmit }) => {


  return (
    <Formik
      initialValues={values}
      onSubmit={handleSubmit}
    >
      <div className="mb-4">

        <Row className="mb-4 g-2">

          <Col xs={12}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_company" label="Company name (if Applicable)"
                value={values.delivery_company}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'><CompanyIcon /></InputAdornment>
                  )
                }}
              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_firstname" label="Firstname"
                value={values.delivery_firstname}
                onChange={handleChange}
                error={!!Boolean(errors.delivery_firstname)}
                helperText={errors.delivery_firstname}

              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_lastname" label="Lastname"
                value={values.delivery_lastname}
                onChange={handleChange}
                error={!!Boolean(errors.delivery_lastname)}
                helperText={errors.delivery_lastname}

              />
            </FormControl>

          </Col>


          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_number_street" label="Number & Street"
                value={values.delivery_number_street}
                onChange={handleChange}
                error={!!Boolean(errors.delivery_number_street)}
                helperText={errors.delivery_number_street}

              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_suburb" label="Suburb/Town"
                value={values.delivery_suburb}
                onChange={handleChange}
                error={!!Boolean(errors.delivery_suburb)}
                helperText={errors.delivery_suburb}
              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <InputLabel id="owner-state-label">State</InputLabel>
              <Select name="delivery_state"
                defaultValue=""
                labelId="delivery-state-label"
                id="delivery-state"
                label="State"
                variant="outlined"
                onChange={handleChange}
                value={values.delivery_state}
                error={!!Boolean(errors.delivery_state)}
              >
                <MenuItem selected value=""><em>None</em></MenuItem>
                <MenuItem value="ACT">Australian Capital Territory</MenuItem>
                <MenuItem value="NSW">New South Wales</MenuItem>
                <MenuItem value="NT">Northern Territory</MenuItem>
                <MenuItem value="QLD">Queensland</MenuItem>
                <MenuItem value="SA">South Australia</MenuItem>
                <MenuItem value="TAS">Tasmania</MenuItem>
                <MenuItem value="VIC">Victoria</MenuItem>
                <MenuItem value="WA">Western Australia</MenuItem>
              </Select>
              {errors.delivery_state && (
                <div style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px', paddingTop: '2px' }}
                  className="text-danger">{errors.delivery_state}</div>
              )}
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField
                name="delivery_postcode"
                label="Postcode"
                value={values.delivery_postcode}
                onChange={handleChange} // This will now use the enhanced handler
                error={!!Boolean(errors.delivery_postcode)}
                helperText={errors.delivery_postcode}
              />
            </FormControl>

          </Col>

        </Row>
      </div>
    </Formik>
  );
};

export default DeliveryAddress;
